import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ArticleSection from "./components/ArticleSection";
import FeatureSection from "./components/FeatureSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import { siteInfo } from "@/mocks/data";

export default function Home() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.name,
    url: "https://www.damanguan-official.com",
    description: siteInfo.description,
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.damanguan-official.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleSection />
        <FeatureSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}